// test1023
(1023 && 0);
